import React from 'react';
import VisitorBotChatWidget from '@samparkchat/sampark-web-chat/sampark/sampark-chat/screens/VisitorBotChatWidget';

const appId = 'AkNJwIhHbqw2qeJBOPXXLQ11hYnHMnBu';
const secretKey = 'GK3xEYRfxr3Sw46bn1UoUDrwsoqBQMHF0mqBUZCGvt1Vgob4faRZI3B';

const ChatBot: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-extrabold tracking-tight text-gray-900">
          Support Chatbot
        </h1>
        <p className="mt-3 text-gray-600">
          Public FAQ assistant — no login required. Use the chat widget to ask questions.
        </p>
      </div>

      <VisitorBotChatWidget
        appId={appId}
        secretKey={secretKey}
        varientId={'LJ66SqbZprRyqch8sheC463I50ENOb4s'}
        registeredVisitor={null}
      />
    </div>
  );
};

export default ChatBot;
